
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M33.218 21.6H9.4v4.33h23.818z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M23.168 4.084a20.595 20.595 0 0 1 20.15 17.57M40.992 34.602a20.593 20.593 0 0 1-28.575 7.774M4.429 33.689A20.594 20.594 0 0 1 11.11 7.824"}}),_c('path',{attrs:{"stroke":"#234652","d":"M21.166 6.538a2.554 2.554 0 1 1-.98-5.013 2.554 2.554 0 0 1 .98 5.013ZM42.81 34.515a2.553 2.553 0 1 1-.98-5.01 2.553 2.553 0 0 1 .98 5.01ZM5.75 38.102a2.554 2.554 0 1 1-.87-5.034 2.554 2.554 0 0 1 .87 5.034ZM6.807 7.145l4.733.477-.477 4.733M46.09 18.417l-2.674 3.935-3.934-2.673M13.25 46.494l-1.397-4.546L16.4 40.55M11.241 20.31h23.477m-23.477 3.789h23.477M11.5 17.5h23v15.823h-23z"}})])
          )
        }
      }
    